import { Component, OnInit, Input } from '@angular/core';
import { AdditionalObservationListViewModel } from '../../models/create-inspection.model';

@Component({
  selector: 'observation-list-row',
  templateUrl: './observation-list-row.component.html',
  styleUrls: ['./observation-list-row.component.scss']
})
export class ObservationListRowComponent implements OnInit {

  @Input() model: AdditionalObservationListViewModel;

  constructor() { }

  ngOnInit() {
  }

}
